import {Component, OnDestroy, OnInit} from '@angular/core';
import {AccountService, AlertService, GroupService, UserService} from "../services";
import {Subject} from 'rxjs';
import {User} from "../models";
import {ActivatedRoute} from "@angular/router";
import {first} from "rxjs/operators";
import {ServiceService} from "../services/service.service";
import {Service} from "../models/service";
import {ComponentTitleService} from "../services/componentTitle.service";

import {locale as polish} from './i18n/pl';
import {locale as english} from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {CardService} from "../services/card.service";
import {Card} from "../models/card";
import {CardLog} from "../models/cardLog";
import {CardLogService} from "../services/cardLog.service";

@Component({
    templateUrl: './cardErrorLogs.component.html',
    styleUrls: ['./cardErrorLogs.component.scss']
})
export class CardErrorLogsComponent implements OnDestroy, OnInit {
    id: string;
    user: User;
    card: Card;
    card9Expanded: boolean = false;
    view: string = 'preview';
    locale: string = 'pl';
    logs: CardLog[];

    constructor(
        private userService: UserService,
        private alertService: AlertService,
        private accountService: AccountService,
        private route: ActivatedRoute,
        private serviceService: ServiceService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private cardService: CardService,
        private cardLogService: CardLogService,
    ) {
        componentTitleService.clearTitle();
        componentTitleService.addPart('Customers');

        this.translationLoader.loadTranslations(polish, english);
    }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];
        this.user = this.route.snapshot.data.userData;
        this.card = this.route.snapshot.data.cardData;

        this.componentTitleService.addPart(this.user.firstName + ' ' + this.user.lastName);
        this.componentTitleService.addPart('Cards');
        this.componentTitleService.addPart(this.card.cardNumber.toString());
        this.componentTitleService.addPart('Error logs');

        this.cardLogService.findCardErrorLogs(this.card.uuid)
            .pipe(first())
            .subscribe((logs: CardLog[]) => {
                this.logs = logs;
            });
    }

    ngOnDestroy(): void {

    }
}
